module.exports = __webpack_public_path__ + "assets/img/img42.99300776.png";